import { v4 as uuid } from 'uuid';
export const generateNotificationId = ()=>{
    const crypto = globalThis?.crypto;
    if (crypto?.randomUUID !== undefined) {
        return crypto.randomUUID();
    }
    return uuid();
};

//# sourceMappingURL=generateNotificationId.js.map